import { render, staticRenderFns } from "./SlidingSidebar.vue?vue&type=template&id=4bc17198&scoped=true&lang=html&"
import script from "./SlidingSidebar.vue?vue&type=script&lang=js&"
export * from "./SlidingSidebar.vue?vue&type=script&lang=js&"
import style0 from "./SlidingSidebar.vue?vue&type=style&index=0&id=4bc17198&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bc17198",
  null
  
)

export default component.exports